// extracted by mini-css-extract-plugin
module.exports = {"card_hover":"BuildingsList_card_hover__1BYjf","dashboard__card-widget":"BuildingsList_dashboard__card-widget__194er","dashboard_icon":"BuildingsList_dashboard_icon__sEkMy"};